import React, { useState, useRef } from 'react';

import cx from 'classnames';

import itemStyles from 'components/Pages/Admin/GuestPortal/Flights/FlightsTable/index.module.css';
import detailsTableStyles from 'components/Pages/Admin/Itinerary/Details/Table/index.module.css';
import MenuActionsHelper from 'components/shared/MenuActionsHelper';
import Popover from 'components/shared/Popover';

import { SelectDetailsType } from '../SelectDetailsType';
import { FlightEmpty } from './Flight';
import s from './index.module.css';

export function NoData(props) {
  const { item, itemIndex } = props;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const buttonRef = useRef();
  const containerRef = useRef();

  return (
    <div className={cx(itemStyles.container, itemStyles.containerNoData)} ref={containerRef}>
      <div className={itemStyles.block}>
        <FlightEmpty />

        <div className={cx(itemStyles.blockItem, itemStyles.notes)}>
          Delta Sky Lounge is Open <br /> From 7am-12am <br /> Everyday.
        </div>
      </div>

      <div
        ref={buttonRef}
        onClick={() => setIsPopupOpen((f) => !f)}
        className={detailsTableStyles.noTypeClickableCell}
      />
      {isPopupOpen && (
        <Popover
          mountEl={containerRef.current}
          anchorEl={buttonRef.current}
          onClose={() => setIsPopupOpen(false)}
          style={{ top: '40px', left: '40px' }}
          className={s.popover}
        >
          <div className={detailsTableStyles.popup}>
            <SelectDetailsType
              item={item}
              itemIndex={itemIndex}
              onClose={() => setIsPopupOpen(false)}
              // onAfterSelect={onAfterTypeSelected}
            />
            <MenuActionsHelper escOnly />
          </div>
        </Popover>
      )}
    </div>
  );
}
